import { render, staticRenderFns } from "./ProductSummaryItem.vue?vue&type=template&id=19fa08dc&scoped=true&"
import script from "./ProductSummaryItem.vue?vue&type=script&lang=ts&"
export * from "./ProductSummaryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSummaryItem.vue?vue&type=style&index=0&id=19fa08dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa08dc",
  null
  
)

export default component.exports